import { actionReducerMap } from './actionTypes';

export default function reducer(state={}, action) {
  if (action.type in actionReducerMap) {
    return actionReducerMap[action.type](state, action.payload);
  }
  return {}
}